<!-- 
Listing of user authentication logs
-->
<template>
  <div>
    <v-card :class="embedded ? 'v-card--flat' : 'home'">
      <our-table-header
        :listing="listing"
        :search-filters="searchFilters"
        :criteria-mutation="criteriaMutation"
        :expand-multiple="expandMultiple" 
        :has-export="hasExport"
        :no-data-text="noDataText"
        :has-expanders=false
        @update:criteria="refresh"
        @update:pageNumber="updatePageNumber" 
        @click:refresh="refresh" 
        @click:export="exportToExcel" 
        @click:expandAll="expandAll"
        @click:collapseAll="collapseAll" 
        @click:toggleMultiple="toggleMultiple"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging"
        :total-items="listing.paging.totalItems" 
        :rows-per-page-items="rowsPerPageItems"
        class="table" 
        must-sort hide-actions
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <our-nav-col :row="props.item.name"/>
            <td>{{ props.item.date | compactDateTime }}</td>
            <td>{{ props.item.userEmail }}</td>
            <td>{{ props.item.action }}</td>
            <td>{{ props.item.description }}</td>
          </tr>
        </template>
      </v-data-table>
      <our-table-footer :paging="listing.paging" @update:pageNumber="updatePageNumber" @update:rowsPerPage="updateRowsPerPage" />
    </v-card>
  </div>
</template>

<script>
import * as action from "@/store/authentication-logs/action-types";
import * as mutation from "@/store/authentication-logs/mutation-types";
import tableMixins from "@/mixins/table.mixins";
import historyMixins from "@/mixins/history.mixins";
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import VueCodeDiff from "vue-code-diff";
import { AUTHENTICATION_LOGS_EXPORT } from "@/store/claim-types";
import { getSearchFilters } from "@/store/authentication-logs/helpers";

export default {
  components: { VueCodeDiff },
  mixins: [tableMixins, historyMixins, filterMixins, lookupMixins],
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      action: action.LIST,
      exportAction: action.EXPORT,
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      pagingMutation: mutation.LIST_SET_PAGING,
      expandMutation: mutation.LIST_TOGGLE_EXPAND
    };
  },
  computed: {
    headers() {
      const h = [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Date", value: "ActionDate", sortable: this.canSort, width: 200 },
        { text: "Email", value: "UserEmail", sortable: this.canSort },
        { text: "Action", value: "UserAction", sortable: this.canSort },
        { text: "Description", value: "ActionExtraInfo", sortable: false }
      ];
      return h;
    },
    listing() {
      return this.$store.state.authenticationLogs.listing;
    },
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.listing.criteria;
    },
    loaded() {
      return this.listing.loaded;
    },
    hasExport() {
      return this.$store.getters.claims.includes(AUTHENTICATION_LOGS_EXPORT);
    }
  },
  watch: {
    userId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    if (this.listing.keepCriteria) {
      this.$store.commit(mutation.LIST_KEEP_CRITERIA, false);
    } else {
      this.$store.commit(mutation.LIST_CLEAR_CRITERIA);
    }
    this.reload();
  },
  methods: {
    reload() {
      if (!this.disable) {
        this.populate();
      }
    },
    canExpand(log) {
      return log.description;
    },
    isFiltered() {
      return (
        this.userId
      );
    }
  }
};
</script>
